import "./index.css";
import "./snap.css";
import "./soulmaze.css";
import "./mobile.css";
import "./polish.css";
import "./heading-kerning.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-380" data-mp="26abx6m6ztypo" />);
}